module.exports = __webpack_public_path__ + "static/media/twitter.5a98780d.svg";